import { createIntl, createIntlCache } from 'react-intl';

let intl;

/**
 * Initializes static intlProvider's intl context object for formatMessage
 * Should be called once when locale messages are all downloaded and ready
 * @param {string} locale
 * @param {string} defaultLocale
 * @param {Object} messages
 */
export const initializeIntl = (locale, defaultLocale, messages) => {
    // https://github.com/yahoo/react-intl/issues/416
    // should look into IntlGlobalProvider
    // https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#creating-intl-without-using-provider
    const cache = createIntlCache();
    intl = createIntl({ defaultLocale, locale, messages }, cache);
};

/**
 * @param {any} value
 * @param {any} [options]
 * @returns {string}
 */
export const formatMessage = (value, options = undefined) => {
    if (!intl) {
        // if not initialized correctly, gracefully initialize with
        // english defaults and move on. This is mainly for unit tests
        // This should not be getting hit at runtime
        initializeIntl('en-US', 'en-US', undefined);
    }

    return intl.formatMessage(value, options);
};

// Commenting out unused methods for now, can be uncommented if needed in future

// /**
//  * @param {any} value
//  * @param {any} [options]
//  * @returns {string}
//  */
// export const formatDate = (value, options = undefined) => {
//     if (!intl) {
//         // if not initialized correctly, gracefully initialize with
//         // english defaults and move on. This is mainly for unit tests
//         // This should not be getting hit at runtime
//         initializeFormatMessage('en-US', 'en-US', undefined);
//     }

//     return intl.formatDate(value, options);
// };

// /**
//  * @param {any} value
//  * @param {any} [options]
//  * @returns {string}
//  */
// export const formatTime = (value, options = undefined) => {
//     if (!intl) {
//         // if not initialized correctly, gracefully initialize with
//         // english defaults and move on. This is mainly for unit tests
//         // This should not be getting hit at runtime
//         initializeFormatMessage('en-US', 'en-US', undefined);
//     }

//     return intl.formatTime(value, options);
// };

// /**
//  * @param {any} value
//  * @param {any} [options]
//  * @returns {string}
//  */
// export const formatNumber = (value, options = undefined) => {
//     if (!intl) {
//         // if not initialized correctly, gracefully initialize with
//         // english defaults and move on. This is mainly for unit tests
//         // This should not be getting hit at runtime
//         initializeFormatMessage('en-US', 'en-US', undefined);
//     }

//     return intl.formatNumber(value, options);
// };
